import React from 'react';
import PageContainer from '../../components/PageContainer';
import MockupLogsDashboard from '../../components/MockupLogsDashboard';

const MockupLogsDashboardPage = () => (
  <PageContainer constrained>
    <MockupLogsDashboard />
  </PageContainer>
);

export default MockupLogsDashboardPage;
